/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './..\\convo\\defs.defs.js'

const $nsid = 'chat.bsky.moderation.getMessageContext'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  after: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer(), 5),
  ),
  before: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer(), 5),
  ),
  convoId: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  messageId: /*#__PURE__*/ l.string(),
  maxInterleavedSystemMessages: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 1000, minimum: 0 }),
      10,
    ),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  messages: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<ConvoDefs.MessageView>(
          (() => ConvoDefs.messageView) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.SystemMessageView>(
          (() => ConvoDefs.systemMessageView) as any,
        ),
      ],
      false,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
